import { useEffect, useRef, useState } from 'react';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import ChatIcon from '@mui/icons-material/Chat';
import CloseIcon from '@mui/icons-material/Close';
import { Badge, Portal } from '@mui/material';
import Popover from '@mui/material/Popover';
import Button from '@mui/material/Button';
import { showMicrosoftCopilot } from '../copilot/MicrosoftCopilot';
import ChatPanel from './ChatPanel';
import { filterUndefined } from '../../utils/FilterUndefinedObject';
import './ChatWidget.scss';

const getButtonLabel = ({ isButton, open }) => {
  if (isButton) {
    return 'Chat';
  }

  return open ? <CloseIcon fontSize='large' /> : <ChatIcon fontSize='large' />;
};
const defaultProps = {
  title: '',
  open: false,
  onOpen: () => null,
  onSubmit: () => null,
  dataRecords: [],
  showBadge: false,
  buttonMode: false,
  defaultOpen: false,
};

export default function ChatWidget(props) {
  const {
    title,
    open,
    onOpen,
    onSubmit,
    dataRecords,
    showBadge,
    buttonMode,
    defaultOpen,
    ...rest
  } = { ...defaultProps, ...filterUndefined(props) };
  const [anchorEl, setAnchorEl] = useState(null);
  const buttonRef = useRef();
  const handleClick = (event) => {
    // Hide Vizz AI chat when feedback chat is opened
    showMicrosoftCopilot(false);
    setAnchorEl(open ? null : event.currentTarget);
    onOpen(!open, showBadge);
  };

  const id = open ? 'chat-popover' : undefined;

  useEffect(() => {
    if (buttonRef.current && defaultOpen) {
      buttonRef.current.click();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buttonRef]);

  const chatWidget = ({ className, isButton } = {}) => (
    <div className={`chat-widget ${className}`} {...rest}>
      <Badge badgeContent={showBadge ? <PriorityHighIcon /> : undefined} className='badge-content'>
        <Button
          aria-describedby={id}
          variant='contained'
          onClick={handleClick}
          className={`${isButton ? 'btn-primary chat-button-button-mode' : 'btn-secondary chat-button'}`}
          ref={buttonRef}
        >
          {getButtonLabel({ open, isButton })}
        </Button>
      </Badge>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        className={`chat-container ${isButton ? 'right-panel' : 'normal'}`}
      >

        <ChatPanel
          title={title}
          onSubmit={onSubmit}
          dataRecords={dataRecords}
          displayCloseIcon
          onClose={() => {
            setAnchorEl(null);
            onOpen(false, showBadge);
            // Show Vizz AI chat when feedback chat is closed
            showMicrosoftCopilot(true);
          }}
        />
      </Popover>
    </div>
  );

  if (buttonMode) {
    return chatWidget({ className: 'chat-widget-button', isButton: true });
  }
  return (
    <Portal container={document.body}>
      {chatWidget()}
    </Portal>
  );
}
